/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-16 15:21:49
 */
export default [
  {
    path: '/bookManage',
    name: 'bookManage',
    hidden: false,
    meta: {
      title: '助印书籍管理',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/bookManageIndex',
        name: 'bookManageIndex',
        hidden: false,
        meta: {
          title: '助印书籍管理',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/book-manage/manage'], resolve)
      },
      {
        path: '/addBook',
        name: 'addBook',
        hidden: true,
        meta: {
          title: '添加书籍',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/book-manage/add'], resolve)
      },
      {
        path: '/bookManageProgress',
        name: 'bookManageProgress',
        hidden: true,
        meta: {
          title: '进度设置',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/book-manage/book-progress'], resolve)
      },
      {
        path: '/bookPrintInter',
        name: 'bookPrintInter',
        hidden: true,
        meta: {
          title: '助印说明设置',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/book-manage/book-print-inter'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-book.js